module.exports = __webpack_public_path__ + "static/media/news-cmh-affiliate.32260b27.jpg";